import React from 'react';
import InputUploadFile from './InputUploadFile';
import Input from './Input';
import Select from './Select';

class FieldsetContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputs: {}
    }
  }

  checkIfValid = (event) => {
    if (event) {
      this.setState({ allFieldsValid: event.target.value ? true : false });
    }
  }

  addLineBreaks = (string) => {
    if (string) {
      string = string.split('\n').map((text, index) => (
        <React.Fragment key={`${text}-${index}`}>
          {text}
          <br />
        </React.Fragment>
      ));
      return <p>{string}</p>
    } else {
      return null
    }
  }

  compStatusCheck = (obj) => {
    this.setState(prevState => ({
      inputs: {
        ...prevState.inputs,
        [Object.keys(obj)[0]]: obj[Object.keys(obj)[0]]
      }
    }))
    if (this.props.combinedValidation) {
      let status = false
      for (const obj in this.state.inputs) {
        if (!status) {
          status = this.state.inputs[obj]
        }
      }
      if (status) {
        this.props.compStatusCheck({ [this.props.id]: true })
      }
    } else {
      this.props.compStatusCheck(this.state.inputs)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.inputs !== prevState.inputs) {
      if (this.props.combinedValidation) {
        let status = false
        for (const obj in this.state.inputs) {
          if (!status) {
            status = this.state.inputs[obj]
          }
        }
        if (status) {
          this.props.compStatusCheck({ [this.props.id]: true })
        }
      } else {
        this.props.compStatusCheck(this.state.inputs)
      }
    }
  }

  render() {
    const { projectId, content, fieldsetAlias, fieldsetId, field_set_description } = this.props;
    return (
      <>
        <h5>{fieldsetAlias}</h5>
        {
          this.addLineBreaks(field_set_description)
        }
        {
          content.map((inputElement, i) => {
            if (inputElement.unit === 'file') {
              return (
                <div
                  key={projectId + '-' + fieldsetId + '-' + inputElement.key + '-' + i}
                >
                  <label>{inputElement.field_alias}</label>
                  <InputUploadFile
                    id={inputElement.key}
                    handleDrop={this.handleDrop}
                    projectid={projectId}
                    required={inputElement.required}
                    getResponse={this.props.getResponse}
                    initializedCall={this.props.initializedCall}
                    compStatusCheck={this.compStatusCheck}
                  />
                </div>
              )
            } else if (inputElement.unit === 'select') {
              const inputValue = inputElement.data_from_db.length !== 0 ? inputElement.data_from_db.value : inputElement.default_value;
              return (
                <Select
                  id={inputElement.key}
                  label={inputElement.field_alias}
                  options={inputElement.options}
                  value={inputValue}
                  required={inputElement.required}
                  key={projectId + '-' + fieldsetId + '-' + inputElement.key + i}
                  compStatusCheck={this.compStatusCheck}
                />
              )
            } else {
              const inputValue = inputElement.data_from_db.length !== 0 ? inputElement.data_from_db.value : inputElement.default_value;
              return (
                <Input
                  label={inputElement.field_alias}
                  unit={inputElement.unit}
                  id={inputElement.key}
                  datatype={inputElement.datatype}
                  key={projectId + '-' + fieldsetId + '-' + inputElement.key + '-' + i}
                  readOnly={inputElement.readonly}
                  checkIfValid={this.checkIfValid}
                  value={inputValue}
                  projectid={projectId}
                  required={inputElement.required}
                  compStatusCheck={this.compStatusCheck}
                />
              )
            }
          })
        }
      </>
    )
  }
}

export default FieldsetContent